module.exports = __webpack_public_path__ + "static/media/newData.748320ed.mp3";